import Connector2 from "./Connector2";

function Connector3({ name1, name2, name3 }) {
  const sons = [
    { name: name1, placeholder: "Son 1" },
    { name: name2, placeholder: "Son 2" },
    { name: name3, placeholder: "Son 3" },
  ];

  return (
    <div style={{ maxWidth: 700, margin: "0 auto" }}>
      <svg
        width="100%"
        viewBox="0 0 700 36"
        preserveAspectRatio="xMidYMin meet"
        style={{ display: "block", overflow: "visible" }}
      >
        <line x1="117" y1="0" x2="583" y2="0" stroke="#aaa" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
        <line x1="117" y1="0" x2="117" y2="24" stroke="#aaa" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
        <polygon points="112,24 117,32 122,24" fill="#aaa" />
        <line x1="350" y1="0" x2="350" y2="24" stroke="#aaa" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
        <polygon points="345,24 350,32 355,24" fill="#aaa" />
        <line x1="583" y1="0" x2="583" y2="24" stroke="#aaa" strokeWidth="1.5" vectorEffect="non-scaling-stroke" />
        <polygon points="578,24 583,32 588,24" fill="#aaa" />
      </svg>
      <div style={{ display: "flex", gap: 12, marginTop: -2 }}>
        {sons.map((s) => (
          <div key={s.name} style={{ flex: 1 }}>
            <div className="lbl">Son</div>
            <input type="text" name={s.name} className="text-center" placeholder={s.placeholder} />
            <Connector2 name1={`${s.name}Child1`} name2={`${s.name}Child2`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Connector3;
